<div class="page">

  <section class="telework-schedule">
    <h2 class="sr-only">
      <div style="display:flex; align-items:center; gap:8px; flex-wrap:wrap;">

        @if (teleworkReports && teleworkReports.length > 0) {
          <label>
            {{ teleworkReports[0].divisinName }} :
          </label>
        }

        <span>Employee Office Status :</span>

        <mat-icon aria-label="In Office"
          matTooltip="In Office"
          class="telework_section-icon telework_office-icon">
          location_city
        </mat-icon>
        <span>-> In Office</span>

        <mat-icon aria-label="Telework"
          matTooltip="Telework"
          class="telework_section-icon telework_telework-icon">
          home
        </mat-icon>
        <span>-> Telework</span> &nbsp;

        <mat-icon matTooltip="Non-Duty Days/Offline" class="telework_section-icon telework_offline-icon">clear</mat-icon>
        <span>-> Non-Duty Days/Offline</span>
        <a [routerLink]="['/my-profile']">  Back </a>
      </div>
    </h2>

    @if (!teleworkReports || teleworkReports.length === 0) {
      <div class="empty">
        @if (!loading) {
          <div>
            No telework records to display.
          </div>
        }
      </div>
    }
    @if (loading) {
      <div class="overlay">
        <mat-spinner class="my-black-spinner"></mat-spinner>
      </div>
    }

    <!-- Single-icon template: Office > Telework > — -->
    <ng-template #dayCell let-office="office" let-telework="telework">
      @if (office || telework) {
        @if (office) {
          <mat-icon
            aria-label="In Office"
            matTooltip="In Office"
            class="telework_section-icon telework_office-icon"
          >location_city</mat-icon>
        } @else {
          @if (telework) {
            <mat-icon
              aria-label="Telework"
              matTooltip="Telework"
              class="telework_section-icon telework_telework-icon"
            >home</mat-icon>
          }
        }
      } @else {
        —
      }
    </ng-template>


    @if (teleworkReports.length) {
      <div class="table-actions">
        <div class="filter-row">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Search by name</mat-label>
            <input
              matInput
              type="text"
              [(ngModel)]="nameQuery"
              (ngModelChange)="applyFilter()"
              placeholder="Start typing a name..."
              aria-label="Search employees by name"
              />
              @if (nameQuery) {
                <button
                  mat-icon-button
                  matSuffix
                  (click)="clearSearch()"
                  aria-label="Clear search"
                  >
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="search-field">
              <mat-label>Search by section</mat-label>
              <input
                matInput
                type="text"
                [(ngModel)]="sectionQuery"
                (ngModelChange)="applyFilter()"
                placeholder="Start typing a section name..."
                aria-label="Search employees by section"
                />
                @if (sectionQuery) {
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="clearSectionSearch()"
                    aria-label="Clear search"
                    >
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>
            </div>
            <div class="result-info">
              Showing {{ filteredReports.length }} of {{ teleworkReports.length }} : Today &nbsp; <mat-icon aria-label="In Office"
              matTooltip="In Office"
              class="telework_section-icon telework_office-icon">
              location_city
              </mat-icon> <a  (click) ="getOfficeData()">  &nbsp;<label class="link">  {{ officecount}} </label></a> &nbsp; &nbsp;  <mat-icon aria-label="Telework"
              matTooltip="Telework"
              class="telework_section-icon telework_telework-icon">
              home
              </mat-icon> <a  (click) ="getTeleworkData()">  &nbsp;<label class="link">  {{ teleworkcount}} </label></a> &nbsp; &nbsp; <mat-icon matTooltip="Non-Duty Days/Offline" class="telework_section-icon telework_offline-icon">clear</mat-icon> <a  (click) ="getOfflineData()">  &nbsp;<label class="link"> {{ offlinecount }} </label></a>
              &nbsp; &nbsp; <a  (click) ="applyFilter()">  <label class="link"> Clear Filter </label></a>
            </div>
          </div>
        }


        @if (teleworkReports && teleworkReports.length > 0) {
          <div class="table-wrapper">
            <table class="schedule-table" role="table" aria-label="Telework schedule by employee">
              <thead>
                <tr>
                  <th rowspan="2" data-label="Name" class="col-name">Name</th>
                  <th colspan="7" class="col-group">Pay Week</th>
                  <th colspan="7" class="col-group">Non-Pay Week</th>
                </tr>
                <tr>
                  <!-- Pay Week -->
                  <th  data-label="Name" class="col-day">Sun</th><th  data-label="Name" class="col-day">Mon</th><th class="col-day">Tue</th><th class="col-day">Wed</th><th class="col-day">Thu</th><th class="col-day">Fri</th><th class="col-day">Sat</th>
                  <!-- Non-Pay Week -->
                  <th  data-label="Name" class="col-day">Sun</th><th class="col-day">Mon</th><th class="col-day">Tue</th><th class="col-day">Wed</th><th class="col-day">Thu</th><th class=".col-day">Fri</th><th class="col-day">Sat</th>
                </tr>
              </thead>
              <tbody>
                @for (r of filteredReports; track trackByEmp($index, r)) {
                  <tr>
                    <td scope="row" class="cell-name-empname"><strong>{{ r?.employeeName || '—' }} </strong>
                    {{ (r?.startTime ? ((r?.startTime?.replace('.', ':') + ' ' + (r.startAMPM || '')).trim()) : '') || '—' }} -
                    {{ (r?.endTime ? ((r?.endTime?.replace('.', ':') + ' ' + (r.endAMPM || '')).trim()) : '') || '—' }}
                    <br><em>{{ r?.sectionName || '—' }}</em>
                  </td>
                  <!-- Sunday -->
                  <td
                    [ngClass]="payweek ? (todayday === 0 ? 'pay-active-today' : 'pay-active') : 'cell-day'"
                    >
                  @switch (r?.poSunday === 'N'
                    ? 'offline'
                    : (r?.poSunday =='true' ? 'office' : (r?.ptSunday == 'false' ? 'office' : 'telework'))) {
                    @case ('offline') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Offline" matTooltip="Non-Duty Days/Offline"
                        class="telework_section-icon telework_offline-icon">clear</mat-icon>
                      </span>
                    }
                    @case ('office') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="In Office" matTooltip="In Office"
                        class="telework_section-icon telework_office-icon">location_city</mat-icon>
                      </span>
                    }
                    @case ('telework') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Telework" matTooltip="Telework"
                        class="telework_section-icon telework_telework-icon">home</mat-icon>
                      </span>
                    }
                    @default {
                      <span>—</span>
                    }
                  }
                </td>
                <!-- Pay Week -->
                <!-- Monday -->
                <td
                  [ngClass]="payweek ? (todayday === 1 ? 'pay-active-today' : 'pay-active') : 'cell-day'"
                  >
                  @switch (r?.poMonday === 'N'
                    ? 'offline'
                    : (r?.poMonday =='true' ? 'office' : (r?.ptMonday == 'false' ? 'office' : 'telework'))) {
                    @case ('offline') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Offline" matTooltip="Non-Duty Days/Offline"
                        class="telework_section-icon telework_offline-icon">clear</mat-icon>
                      </span>
                    }
                    @case ('office') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="In Office" matTooltip="In Office"
                        class="telework_section-icon telework_office-icon">location_city</mat-icon>
                      </span>
                    }
                    @case ('telework') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Telework" matTooltip="Telework"
                        class="telework_section-icon telework_telework-icon">home</mat-icon>
                      </span>
                    }
                    @default {
                      <span>—</span>
                    }
                  }
                </td>
                <!-- Tuesday -->
                <td
                  [ngClass]="payweek  ? todayday==2 ? 'pay-active-today' : 'pay-active' : 'cell-day'"
                  >
                  @switch (r?.poTuesday === 'N'
                    ? 'offline'
                    : (r?.poTuesday == 'true' ? 'office' : (r?.ptTuesday == 'false' ? 'office' : 'telework'))) {
                    @case ('offline') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Offline" matTooltip="Non-Duty Days/Offline"
                        class="telework_section-icon telework_offline-icon">clear</mat-icon>
                      </span>
                    }
                    @case ('office') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="In Office" matTooltip="In Office"
                        class="telework_section-icon telework_office-icon">location_city</mat-icon>
                      </span>
                    }
                    @case ('telework') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Telework" matTooltip="Telework"
                        class="telework_section-icon telework_telework-icon">home</mat-icon>
                      </span>
                    }
                    @default {
                      <span>—</span>
                    }
                  }
                </td>
                <!-- Wednesday -->
                <td
                  [ngClass]="payweek  ? todayday==3 ? 'pay-active-today' : 'pay-active' : 'cell-day'"
                  >
                  @switch (r?.poWednesday === 'N'
                    ? 'offline'
                    : (r?.poWednesday == 'true' ? 'office' : (r?.ptWednesday == 'false' ? 'office' : 'telework'))) {
                    @case ('offline') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Offline" matTooltip="Non-Duty Days/Offline"
                        class="telework_section-icon telework_offline-icon">clear</mat-icon>
                      </span>
                    }
                    @case ('office') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="In Office" matTooltip="In Office"
                        class="telework_section-icon telework_office-icon">location_city</mat-icon>
                      </span>
                    }
                    @case ('telework') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Telework" matTooltip="Telework"
                        class="telework_section-icon telework_telework-icon">home</mat-icon>
                      </span>
                    }
                    @default {
                      <span>—</span>
                    }
                  }
                </td>
                <!-- Thursday -->
                <td
                  [ngClass]="payweek  ? todayday==4 ? 'pay-active-today' : 'pay-active' : 'cell-day'"
                  >
                  @switch (r?.poThursday === 'N'
                    ? 'offline'
                    : (r?.poThursday == 'true' ? 'office' : (r?.ptThursday == 'false' ? 'office' : 'telework'))) {
                    @case ('offline') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Offline" matTooltip="Non-Duty Days/Offline"
                        class="telework_section-icon telework_offline-icon">clear</mat-icon>
                      </span>
                    }
                    @case ('office') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="In Office" matTooltip="In Office"
                        class="telework_section-icon telework_office-icon">location_city</mat-icon>
                      </span>
                    }
                    @case ('telework') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Telework" matTooltip="Telework"
                        class="telework_section-icon telework_telework-icon">home</mat-icon>
                      </span>
                    }
                    @default {
                      <span>—</span>
                    }
                  }
                </td>
                <!-- Friday -->
                <td
                  [ngClass]="payweek  ? todayday==5 ? 'pay-active-today' : 'pay-active' : 'cell-day'"
                  >
                  @switch (r?.poFriday === 'N'
                    ? 'offline'
                    : (r?.poFriday == 'true' ? 'office' : (r?.ptFriday == 'false' ? 'office' : 'telework'))) {
                    @case ('offline') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Offline" matTooltip="Non-Duty Days/Offline"
                        class="telework_section-icon telework_offline-icon">clear</mat-icon>
                      </span>
                    }
                    @case ('office') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="In Office" matTooltip="In Office"
                        class="telework_section-icon telework_office-icon">location_city</mat-icon>
                      </span>
                    }
                    @case ('telework') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Telework" matTooltip="Telework"
                        class="telework_section-icon telework_telework-icon">home</mat-icon>
                      </span>
                    }
                    @default {
                      <span>—</span>
                    }
                  }
                </td>
                <!-- Saturday -->
                <td
                  [ngClass]="payweek  ? todayday==6 ? 'pay-active-today' : 'pay-active' : 'cell-day'"
                  >
                  @switch (r?.poSaturday === 'N'
                    ? 'offline'
                    : (r?.poSaturday == 'true' ? 'office' : (r?.ptSaturday == 'false' ? 'office' : 'telework'))) {
                    @case ('offline') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Offline" matTooltip="Non-Duty Days/Offline"
                        class="telework_section-icon telework_offline-icon">clear</mat-icon>
                      </span>
                    }
                    @case ('office') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="In Office" matTooltip="In Office"
                        class="telework_section-icon telework_office-icon">location_city</mat-icon>
                      </span>
                    }
                    @case ('telework') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Telework" matTooltip="Telework"
                        class="telework_section-icon telework_telework-icon">home</mat-icon>
                      </span>
                    }
                    @default {
                      <span>—</span>
                    }
                  }
                </td>
                <!-- Sunday -->
                <td
                  [ngClass]="!payweek ? (todayday === 0 ? 'pay-active-today' : 'pay-active') : 'cell-day'"
                  >
                  @switch (r?.npoSunday === 'N'
                    ? 'offline'
                    : (r?.npoSunday =='true' ? 'office' : (r?.nptSunday == 'false' ? 'office' : 'telework'))) {
                    @case ('offline') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Offline" matTooltip="Non-Duty Days/Offline"
                        class="telework_section-icon telework_offline-icon">clear</mat-icon>
                      </span>
                    }
                    @case ('office') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="In Office" matTooltip="In Office"
                        class="telework_section-icon telework_office-icon">location_city</mat-icon>
                      </span>
                    }
                    @case ('telework') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Telework" matTooltip="Telework"
                        class="telework_section-icon telework_telework-icon">home</mat-icon>
                      </span>
                    }
                    @default {
                      <span>—</span>
                    }
                  }
                </td>
                <!-- Monday -->
                <td
                  [ngClass]="!payweek  ? todayday==1 ? 'pay-active-today' : 'pay-active' : 'cell-day'"
                  >
                  @switch (r?.npoMonday === 'N'
                    ? 'offline'
                    : (r?.npoMonday == 'true' ? 'office' : (r?.nptMonday == 'false' ? 'office' : 'telework'))) {
                    @case ('offline') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Offline" matTooltip="Non-Duty Days/Offline"
                        class="telework_section-icon telework_offline-icon">clear</mat-icon>
                      </span>
                    }
                    @case ('office') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="In Office" matTooltip="In Office"
                        class="telework_section-icon telework_office-icon">location_city</mat-icon>
                      </span>
                    }
                    @case ('telework') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Telework" matTooltip="Telework"
                        class="telework_section-icon telework_telework-icon">home</mat-icon>
                      </span>
                    }
                    @default {
                      <span>—</span>
                    }
                  }
                </td>
                <td
                  [ngClass]="!payweek  ? todayday==2 ? 'pay-active-today' : 'pay-active' : 'cell-day'"
                  >
                  @switch (r?.npoTuesday === 'N'
                    ? 'offline'
                    : (r?.npoTuesday == 'true' ? 'office' : (r?.nptTuesday == 'false' ? 'office' : 'telework'))) {
                    @case ('offline') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Offline" matTooltip="Non-Duty Days/Offline"
                        class="telework_section-icon telework_offline-icon">clear</mat-icon>
                      </span>
                    }
                    @case ('office') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="In Office" matTooltip="In Office"
                        class="telework_section-icon telework_office-icon">location_city</mat-icon>
                      </span>
                    }
                    @case ('telework') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Telework" matTooltip="Telework"
                        class="telework_section-icon telework_telework-icon">home</mat-icon>
                      </span>
                    }
                    @default {
                      <span>—</span>
                    }
                  }
                </td>
                <!-- Wednesday -->
                <td
                  [ngClass]="!payweek  ? todayday==3 ? 'pay-active-today' : 'pay-active' : 'cell-day'"
                  >
                  @switch (r?.npoWednesday === 'N'
                    ? 'offline'
                    : (r?.npoWednesday == 'true' ? 'office' : (r?.nptWednesday == 'false' ? 'office' : 'telework'))) {
                    @case ('offline') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Offline" matTooltip="Non-Duty Days/Offline"
                        class="telework_section-icon telework_offline-icon">clear</mat-icon>
                      </span>
                    }
                    @case ('office') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="In Office" matTooltip="In Office"
                        class="telework_section-icon telework_office-icon">location_city</mat-icon>
                      </span>
                    }
                    @case ('telework') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Telework" matTooltip="Telework"
                        class="telework_section-icon telework_telework-icon">home</mat-icon>
                      </span>
                    }
                    @default {
                      <span>—</span>
                    }
                  }
                </td>
                <!-- Thursday -->
                <td
                  [ngClass]="!payweek  ? todayday==4 ? 'pay-active-today' : 'pay-active' : 'cell-day'"
                  >
                  @switch (r?.npoThursday === 'N'
                    ? 'offline'
                    : (r?.npoThursday == 'true' ? 'office' : (r?.nptThursday == 'false' ? 'office' : 'telework'))) {
                    @case ('offline') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Offline" matTooltip="Non-Duty Days/Offline"
                        class="telework_section-icon telework_offline-icon">clear</mat-icon>
                      </span>
                    }
                    @case ('office') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="In Office" matTooltip="In Office"
                        class="telework_section-icon telework_office-icon">location_city</mat-icon>
                      </span>
                    }
                    @case ('telework') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Telework" matTooltip="Telework"
                        class="telework_section-icon telework_telework-icon">home</mat-icon>
                      </span>
                    }
                    @default {
                      <span>—</span>
                    }
                  }
                </td>
                <!-- Friday -->
                <td
                  [ngClass]="!payweek  ? todayday==5 ? 'pay-active-today' : 'pay-active' : 'cell-day'"
                  >
                  @switch (r?.npoFriday === 'N'
                    ? 'offline'
                    : (r?.npoFriday == 'true' ? 'office' : (r?.nptFriday == 'false' ? 'office' : 'telework'))) {
                    @case ('offline') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Offline" matTooltip="Non-Duty Days/Offline"
                        class="telework_section-icon telework_offline-icon">clear</mat-icon>
                      </span>
                    }
                    @case ('office') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="In Office" matTooltip="In Office"
                        class="telework_section-icon telework_office-icon">location_city</mat-icon>
                      </span>
                    }
                    @case ('telework') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Telework" matTooltip="Telework"
                        class="telework_section-icon telework_telework-icon">home</mat-icon>
                      </span>
                    }
                    @default {
                      <span>—</span>
                    }
                  }
                </td>
                <td
                  [ngClass]="!payweek  ? todayday==6 ? 'pay-active-today' : 'pay-active' : 'cell-day'"
                  >
                  @switch (r?.npoSaturday === 'N'
                    ? 'offline'
                    : (r?.npoSaturday == 'true' ? 'office' : (r?.nptSaturday == 'false' ? 'office' : 'telework'))) {
                    @case ('offline') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Offline" matTooltip="Non-Duty Days/Offline"
                        class="telework_section-icon telework_offline-icon">clear</mat-icon>
                      </span>
                    }
                    @case ('office') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="In Office" matTooltip="In Office"
                        class="telework_section-icon telework_office-icon">location_city</mat-icon>
                      </span>
                    }
                    @case ('telework') {
                      <span class="icon-wrap">
                        <mat-icon aria-label="Telework" matTooltip="Telework"
                        class="telework_section-icon telework_telework-icon">home</mat-icon>
                      </span>
                    }
                    @default {
                      <span>—</span>
                    }
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </section>
</div>